import type { CommonData } from '@/app/common/createCommonData.ts';
import { ampli } from '@/ampli';

export const amplitudeIdentify = (loggedIn: boolean, commonData: CommonData) => {
  const hashedAccountId = commonData.casperResponseProperties?.hashedAccountId || '';
  if (loggedIn && hashedAccountId) {
    ampli.identify(hashedAccountId);
  }
};
